import React from "react";
import routes from "./Route";
import { useRoutes } from "react-router-dom";

const InitialRoute = () => {
  const routing = useRoutes(routes);
  return <>{routing}</>;
};

export default InitialRoute;
